<template>
  <Flex
    direction="column"
    align="center"
  >
    <DiscountsImage />
    <div :class="$style.maxWidth">
      <BaseText>
        {{ $t('marketing.discounts.details.no_customer_have_used') }}
        {{ $t('marketing.discounts.details.email_area') }}
      </BaseText>
    </div>
  </Flex>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DiscountsImage from './DiscountsImage.vue';

export default defineComponent({
  components: {
    DiscountsImage,
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.maxWidth {
  display: inline-block;
  max-width: 320px;
  text-align: center;
}
</style>
